// extracted by mini-css-extract-plugin
module.exports = {"container":"container--Automation-routes__jJAUy","wrapper":"wrapper--Automation-routes__1mycN"};